export default function ComicTitle({ text, shadowColor = "#FF0000", highlightColor = "#f0ae02" }) {
  return (
    <div className="relative inline-block">
      {/* Base layer */}
      <h1 className="comic-text-layer comic-text-base text-6xl md:text-8xl font-black uppercase tracking-tight text-transparent">
        {text}
      </h1>

      {/* Shadow layer */}
      <h1
        className="comic-text-layer comic-text-shadow-red absolute top-0 left-0 text-6xl md:text-8xl font-black uppercase tracking-tight"
        style={{ color: shadowColor }}
      >
        {text}
      </h1>

      {/* Highlight layer */}
      <h1
        className="comic-text-layer comic-text-highlight-orange absolute top-0 left-0 text-6xl md:text-8xl font-black uppercase tracking-tight"
        style={{ color: highlightColor }}
      >
        {text}
      </h1>
    </div>
  );
}
